
// export default () => ({

// })

export default () => ({
    //status: 'authenticating',
    user: null,
    idToken: null,
    //refreshToken: null,
    id: null
})